import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { SectionChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/section-with-changes.interface'
import { toFixedNumber } from '@app/shared/utils/utils'

export function getSectionChanges(
  section: ScopeSection,
  previewSection: ScopeSection,
  isChangeRequest: boolean,
  previewDeliverables: Deliverable[]
): SectionChanges {
  if (!previewSection) previewSection = section

  return {
    markup: {
      old: +section?.getTotalMarkup(true),
      new: +previewSection?.getTotalMarkup(false, previewDeliverables),
    },
    totalProfit: {
      old: section?.getTotalProfit(true)?.amount,
      new: previewSection?.getTotalProfit(false, previewDeliverables)?.amount,
    },
    rateCardTotalHours: {
      old: section?.getAgencyHours(true),
      new: previewSection?.getAgencyHours(!isChangeRequest, previewDeliverables),
    },
    totalSellingPrice: {
      old: section?.getTotalSellingPrice([], true)?.amount,
      new: toFixedNumber(previewSection?.getTotalSellingPrice(previewDeliverables, !isChangeRequest)?.amount ?? 0),
    },
  }
}
